<script>
import Layout from "../Layouts/AdminLayout.vue";
import { onMounted } from "vue";

export default {
    layout: Layout,
};
</script>
<script setup>
import { Head } from "@inertiajs/vue3";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    additional: Object,
});

const breadcrumbs = [
    {
        url: "#",
        label: "Dashboard",
    },
];

onMounted(() => {});
</script>

<template>
    <Head>
        <title>Dashboard</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />
        <div class="row"></div>
    </div>
</template>
